/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileShortcutSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileShortcutSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M11.441 11.42a55.61 55.61 0 0 0 0 3.16h3.116a55.593 55.593 0 0 0 0-3.16h-3.116ZM14.496 16h-2.992c.184 2.755.67 4.064 1.496 4.064.825 0 1.312-1.31 1.496-4.064Zm1.439-3c0 .551-.007 1.075-.02 1.58H19.9a12.563 12.563 0 0 0 0-3.16h-3.985c.013.505.02 1.029.02 1.58Zm-.078-3h3.752c-.653-2.137-2.14-3.417-4.483-3.871.46 1.24.707 2.549.731 3.871Zm-5.714 0c.024-1.322.271-2.631.732-3.871C8.53 6.58 7.045 7.863 6.392 10h3.75Zm0 6H6.39c.653 2.137 2.14 3.417 4.483 3.871a11.738 11.738 0 0 1-.73-3.871Zm5.714 0a11.736 11.736 0 0 1-.732 3.871c2.344-.451 3.83-1.733 4.483-3.871h-3.75Zm-4.353-6h2.992c-.184-2.755-.67-4.065-1.496-4.065-.825 0-1.312 1.31-1.496 4.065ZM6.1 11.42a12.51 12.51 0 0 0 0 3.16h3.985a60.81 60.81 0 0 1 0-3.16H6.1Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M14.457 10h.039c-.184-2.755-.67-4.065-1.496-4.065-.825 0-1.312 1.31-1.496 4.065h.039c.207-2.41.684-3.56 1.457-3.56s1.25 1.15 1.457 3.56Zm-7.89 0c.704-1.782 2.072-2.886 4.121-3.329.058-.182.12-.363.187-.542C8.53 6.58 7.045 7.863 6.392 10h.175Zm12.866 0h.176c-.653-2.137-2.14-3.417-4.483-3.871.066.18.129.36.186.543 2.05.444 3.418 1.546 4.121 3.328Zm-7.992 1.42a55.61 55.61 0 0 0-.021 1.832c.002-.468.01-.91.021-1.328h3.116A54.446 54.446 0 0 1 14.58 13c0-.563-.008-1.088-.022-1.58h-3.116ZM14.496 16h-2.992c.012.174.025.342.039.505h2.914c.014-.163.027-.331.039-.505Zm1.439-2.748c-.002.46-.009.9-.02 1.329h.011a61.33 61.33 0 0 0 .009-1.329Zm4.062 0c.013-.612-.02-1.224-.097-1.833h-3.985c.005.166.008.335.011.505H19.9c.056.441.088.885.098 1.328ZM10.143 16H6.39c.053.174.112.342.176.505h3.576c.02 1.13.204 2.252.545 3.328l.186.038a11.738 11.738 0 0 1-.73-3.871Zm4.982 3.871c.46-1.24.708-2.549.732-3.871h3.751a6.702 6.702 0 0 1-.175.505h-3.576a11.737 11.737 0 0 1-.545 3.328 8.653 8.653 0 0 1-.187.038Zm-9.122-6.619c-.013-.612.02-1.224.097-1.833h3.985c-.005.166-.008.335-.011.505H6.1c-.056.441-.089.885-.097 1.328Zm4.082 1.328h-.011a61.33 61.33 0 0 1-.009-1.328c.002.46.009.9.02 1.329Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m6.687 19.312.06 3.065-.599.012-.04-2.072-2.334 2.333-.424-.424 2.333-2.334-2.072-.04.012-.6 3.064.06Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m6.75 22.374-.06-3.065-3.066-.06-.011.6h.004l.007-.374 3.065.06.056 2.839h.004Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m5.463 20.11.222.005-2.22 2.22-.113-.113 2.111-2.111Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileShortcutSmall
};
